module.exports = __webpack_public_path__ + "img/luggage-icon.f6461fa1.svg";